var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{attrs:{"value":_vm.value},on:{"change":_vm.onInput}},_vm._l((_vm.options),function(option,optionIdx){return _c('v-radio',{key:optionIdx,staticClass:"form-radio",class:[
      option.class ? option.class : '',
      _vm.value === option.value && option.selectedClass ? option.selectedClass : '',
    ],attrs:{"value":option.value,"label":option.label},scopedSlots:_vm._u([(!option.label)?{key:"label",fn:function(){return [_vm._t("label",null,{"option":option})]},proxy:true}:null],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }